export default __webpack_public_path__ + "static/media/0xd5d86fc8d5c0ea1ac1ac5dfab6e529c9967a45e9.881ca758.webp";